import { Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";

export function EventDialog({ open, onOpenChange, editing, form, setForm, members, saving, onSave, onDelete }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-3xl">
        <DialogHeader>
          <DialogTitle className="font-display">{editing ? "Edit event" : "New event"}</DialogTitle>
          <DialogDescription className="sr-only">Event details</DialogDescription>
        </DialogHeader>
        {form && (
          <div className="space-y-4">
            <div className="space-y-1.5">
              <Label>Title</Label>
              <Input
                value={form.title}
                onChange={(e) => setForm({ ...form, title: e.target.value })}
                placeholder="Soccer practice"
                className="rounded-xl"
                data-testid="event-title-input"
              />
            </div>
            <div className="space-y-1.5">
              <Label>When</Label>
              <Input
                type="datetime-local"
                value={form.start}
                onChange={(e) => setForm({ ...form, start: e.target.value })}
                className="rounded-xl"
                data-testid="event-datetime-input"
              />
            </div>
            <div className="flex items-center justify-between rounded-xl bg-secondary/50 px-4 py-2.5">
              <Label>All day</Label>
              <Switch checked={form.all_day} onCheckedChange={(v) => setForm({ ...form, all_day: v })} data-testid="event-allday-switch" />
            </div>
            <div className="space-y-1.5">
              <Label>Who</Label>
              <Select value={form.member_id} onValueChange={(v) => setForm({ ...form, member_id: v })}>
                <SelectTrigger className="rounded-xl" data-testid="event-member-select">
                  <SelectValue placeholder="Family" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="none">Whole family</SelectItem>
                  {members.map((m) => (
                    <SelectItem key={m.id} value={m.id}>
                      {m.name}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            <div className="space-y-1.5">
              <Label>Location (optional)</Label>
              <Input
                value={form.location}
                onChange={(e) => setForm({ ...form, location: e.target.value })}
                placeholder="Community park"
                className="rounded-xl"
                data-testid="event-location-input"
              />
            </div>
          </div>
        )}
        <DialogFooter className="flex-row justify-between gap-2 sm:justify-between">
          {editing ? (
            <Button variant="ghost" className="rounded-xl text-destructive" onClick={onDelete} data-testid="event-delete-btn">
              <Trash2 className="mr-1.5 h-4 w-4" /> Delete
            </Button>
          ) : (
            <span />
          )}
          <Button className="rounded-xl" onClick={onSave} disabled={saving} data-testid="event-save-btn">
            {saving ? "Saving…" : "Save"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
